import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { QUERY_KEYS } from '@/constants';

import {
  IJobSearchingPayload,
  INotificationSearchingPayload,
} from '@/features/regulatory-intake/intake-list/interfaces';
import { IntakeListService } from '@/features/regulatory-intake/intake-list/services';

export const useNotificationSearching = (payload: INotificationSearchingPayload) => {
  return useQuery({
    queryKey: QUERY_KEYS.regulatoryIntake.notificationSearch(payload),
    queryFn: () => IntakeListService.notificationSearch(payload),
    placeholderData: keepPreviousData,
  });
};

export const useJobSearching = (payload: IJobSearchingPayload) => {
  return useQuery({
    queryKey: QUERY_KEYS.regulatoryIntake.jobSearch(payload),
    queryFn: () => IntakeListService.jobSearch(payload),
    placeholderData: keepPreviousData,
  });
};

export const useJobManualTriggerMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => await IntakeListService.jobManualTrigger(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEYS.source.sourceDetails() });
      queryClient.invalidateQueries({ queryKey: QUERY_KEYS.regulatoryIntake.jobSearch({}) });
    },
  });
};

export const useJobRetryMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (jobId: string) => await IntakeListService.jobRetry(jobId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEYS.regulatoryIntake.jobSearch({}) });
    },
  });
};

export const useSourceDetails = () => {
  return useQuery({
    queryKey: QUERY_KEYS.source.sourceDetails(),
    queryFn: async () => await IntakeListService.sourceDetails(),
    placeholderData: keepPreviousData,
  });
};
